Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var dateFns = require('date-fns');
var MaterialTable = require('material-table');
var frontend = require('@ds-developer/frontend');
var Label = require('@ds-developer/label');
var reactFeather = require('react-feather');
var AddBox = require('@material-ui/icons/AddBox');
var ArrowUpward = require('@material-ui/icons/ArrowUpward');
var Check = require('@material-ui/icons/Check');
var ChevronLeft = require('@material-ui/icons/ChevronLeft');
var ChevronRight = require('@material-ui/icons/ChevronRight');
var Clear = require('@material-ui/icons/Clear');
var DeleteOutline = require('@material-ui/icons/DeleteOutline');
var Edit = require('@material-ui/icons/Edit');
var FilterList = require('@material-ui/icons/FilterList');
var FirstPage = require('@material-ui/icons/FirstPage');
var LastPage = require('@material-ui/icons/LastPage');
var Remove = require('@material-ui/icons/Remove');
var SaveAlt = require('@material-ui/icons/SaveAlt');
var Search = require('@material-ui/icons/Search');
var ViewColumn = require('@material-ui/icons/ViewColumn');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MaterialTable__default = /*#__PURE__*/_interopDefaultLegacy(MaterialTable);
var Label__default = /*#__PURE__*/_interopDefaultLegacy(Label);
var AddBox__default = /*#__PURE__*/_interopDefaultLegacy(AddBox);
var ArrowUpward__default = /*#__PURE__*/_interopDefaultLegacy(ArrowUpward);
var Check__default = /*#__PURE__*/_interopDefaultLegacy(Check);
var ChevronLeft__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeft);
var ChevronRight__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRight);
var Clear__default = /*#__PURE__*/_interopDefaultLegacy(Clear);
var DeleteOutline__default = /*#__PURE__*/_interopDefaultLegacy(DeleteOutline);
var Edit__default = /*#__PURE__*/_interopDefaultLegacy(Edit);
var FilterList__default = /*#__PURE__*/_interopDefaultLegacy(FilterList);
var FirstPage__default = /*#__PURE__*/_interopDefaultLegacy(FirstPage);
var LastPage__default = /*#__PURE__*/_interopDefaultLegacy(LastPage);
var Remove__default = /*#__PURE__*/_interopDefaultLegacy(Remove);
var SaveAlt__default = /*#__PURE__*/_interopDefaultLegacy(SaveAlt);
var Search__default = /*#__PURE__*/_interopDefaultLegacy(Search);
var ViewColumn__default = /*#__PURE__*/_interopDefaultLegacy(ViewColumn);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
var tableIcons = {
  Add: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(AddBox__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Check: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Check__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Clear: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Clear__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Delete: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(DeleteOutline__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  DetailPanel: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronRight__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Edit: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Edit__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Export: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(SaveAlt__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Filter: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(FilterList__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  FirstPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(FirstPage__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  LastPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(LastPage__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  NextPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronRight__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  PreviousPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronLeft__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ResetSearch: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Clear__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Search: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Search__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  SortArrow: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ArrowUpward__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ThirdStateCheck: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Remove__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ViewColumn: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ViewColumn__default['default'], _assign({}, props, {
      ref: ref
    }));
  })
};
var useStyles = core.makeStyles(function () {
  return {
    root: {}
  };
});
var invoicePaidToLabelText = function invoicePaidToLabelText(paid) {
  return paid ? "Flag as unpaid" : "Remove flag";
};
var normalizeDateToString = function normalizeDateToString(date) {
  return typeof date === "string" ? dateFns.parseISO(date) : date;
};
var InvoicesTable = function InvoicesTable(_a) {
  var _b = _a.loading,
    loading = _b === void 0 ? false : _b,
    _c = _a.onClickDownload,
    onClickDownload = _c === void 0 ? function () {} : _c,
    onClickUpdateStatus = _a.onClickUpdateStatus,
    _d = _a.invoices,
    invoices = _d === void 0 ? [] : _d,
    _e = _a.showPaid,
    showPaid = _e === void 0 ? true : _e;
  var classes = useStyles();
  var actions = [function (invoice) {
    return {
      icon: function icon() {
        return React__default['default'].createElement(reactFeather.Download, {
          "aria-label": "download"
        });
      },
      onClick: function onClick(_event, data) {
        if (!Array.isArray(data)) {
          onClickDownload(data.id);
        }
      },
      tooltip: "Download PDF",
      hidden: !invoice.pdfCreated
    };
  }];
  if (onClickUpdateStatus) {
    actions.unshift(function (invoice) {
      return {
        icon: function icon() {
          return React__default['default'].createElement(reactFeather.Flag, {
            color: invoice.paid ? "currentcolor" : "red",
            "aria-label": invoicePaidToLabelText(invoice.paid)
          });
        },
        onClick: function onClick(_event, invoice) {
          return !Array.isArray(invoice) && onClickUpdateStatus(invoice);
        },
        tooltip: invoicePaidToLabelText(invoice.paid)
      };
    });
  }
  return React__default['default'].createElement(core.Box, {
    m: 1,
    className: classes.root + " mobile-friendly has-actions"
  }, React__default['default'].createElement(MaterialTable__default['default'], {
    icons: tableIcons,
    isLoading: loading,
    columns: [{
      title: "Date",
      field: "invoiceDate",
      sorting: true,
      searchable: false,
      defaultSort: "desc",
      render: function render(_a) {
        var invoiceDate = _a.invoiceDate;
        return React__default['default'].createElement("div", {
          "data-label": "Date"
        }, dateFns.format(new Date(invoiceDate), "dd/MM/yyyy"));
      },
      customSort: function customSort(a, b) {
        return dateFns.differenceInMilliseconds(normalizeDateToString(a.invoiceDate), normalizeDateToString(b.invoiceDate));
      }
    }, {
      title: "Invoice number",
      field: "invoiceId",
      sorting: true,
      searchable: true,
      render: function render(_a) {
        var invoiceId = _a.invoiceId;
        return React__default['default'].createElement("div", {
          "data-label": "Invoice number"
        }, invoiceId);
      }
    }, {
      title: "",
      field: "paid",
      sorting: false,
      searchable: false,
      render: function render(_a) {
        var paid = _a.paid;
        return paid ? React__default['default'].createElement(Label__default['default'], {
          color: "success"
        }, "PAID") : React__default['default'].createElement(Label__default['default'], {
          color: "error"
        }, "UNPAID");
      },
      hidden: !showPaid
    }, {
      title: "Balance",
      field: "value",
      sorting: true,
      searchable: false,
      render: function render(rowData) {
        return React__default['default'].createElement("div", {
          "data-label": "Balance"
        }, frontend.formatCurrency(rowData.value, false));
      }
    }],
    actions: actions,
    options: {
      actionsColumnIndex: -1,
      draggable: false,
      headerStyle: {
        whiteSpace: "nowrap",
        paddingRight: 10
      },
      paging: true,
      emptyRowsWhenPaging: false,
      pageSize: 10,
      search: false,
      showTitle: false,
      toolbar: false
    },
    localization: {
      header: {
        actions: "Actions"
      },
      toolbar: {
        searchPlaceholder: "Search for invoices"
      },
      body: {
        emptyDataSourceMessage: "No invoices to display"
      }
    },
    components: {
      Row: function Row(props) {
        return React__default['default'].createElement(MaterialTable.MTableBodyRow, _assign({
          "data-test": "invoice-table-row-" + props.index
        }, props));
      }
    },
    data: invoices
  }));
};
exports.default = InvoicesTable;